module.exports = __webpack_public_path__ + "img/10_103.9841680a.png";